(() => {
  'use strict';

  let observer;

  const activateSearchVariant = () => {
    document.documentElement.classList.add('convert-search-variant');
    document.documentElement.setAttribute('data-convert-search-variant', 'v1');

    setTimeout(() => {
      const searchDetails = document.querySelector('.header__search-wrapper .header__search details');
      if (searchDetails && window.innerWidth <= 989) {
        searchDetails.setAttribute('open', '');

        // Enforce open state via MutationObserver
        if (observer) observer.disconnect();
        observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (!searchDetails.hasAttribute('open')) {
                searchDetails.setAttribute('open', '');
              }
            }
          }
        });
        observer.observe(searchDetails, { attributes: true });

        const searchInput = searchDetails.querySelector('.search__input');
        const searchWrapper = document.querySelector('.header__search-wrapper');

        const updateVisibility = () => {
          if (searchInput && searchWrapper) {
            if (searchInput.value.length > 0) {
              searchWrapper.classList.add('has-text');
            } else {
              searchWrapper.classList.remove('has-text');
            }
          }
        };

        const updateHeaderHeight = () => {
          const stickyHeader = document.querySelector('sticky-header');
          const header = document.querySelector('.header');
          if (stickyHeader) {
            const height = stickyHeader.offsetHeight;
            stickyHeader.style.setProperty('--header-height', `${height}px`);
            // Also set on document element as fallback or if used broadly
            document.documentElement.style.setProperty('--header-height', `${height}px`);
          } else if (header) {
            const height = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
          }
        };

        if (searchInput) {
          searchInput.addEventListener('input', updateVisibility);
          updateVisibility();
        }

        // Initial height update and on resize
        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);
        // Trigger a resize to ensure other theme scripts catch up
        window.dispatchEvent(new Event('resize'));

        // Add to deactivate to clean up listener
        window.convertSearchVariant.updateHeaderHeight = updateHeaderHeight;

        const closeButton = searchDetails.querySelector('.search-modal__close-button');
        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const predictiveSearch = searchDetails.querySelector('.predictive-search');

            if (searchInput) {
              searchInput.value = '';
              searchInput.blur();
              updateVisibility();
            }

            if (predictiveSearch) {
              predictiveSearch.style.display = 'none';
              setTimeout(() => {
                predictiveSearch.style.display = '';
              }, 100);
            }

            searchDetails.setAttribute('open', '');

            // Re-calculate height in case layout shifted
            setTimeout(updateHeaderHeight, 150);
          });
        }
      }
    }, 100);
  };

  const deactivateSearchVariant = () => {
    document.documentElement.classList.remove('convert-search-variant');
    document.documentElement.removeAttribute('data-convert-search-variant');

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (window.convertSearchVariant.updateHeaderHeight) {
      window.removeEventListener('resize', window.convertSearchVariant.updateHeaderHeight);
      window.convertSearchVariant.updateHeaderHeight = null;
    }

    const searchDetails = document.querySelector('.header__search-wrapper .header__search details');
    if (searchDetails) {
      searchDetails.removeAttribute('open');
    }
  };

  window.convertSearchVariant = {
    control() {
      deactivateSearchVariant();
    },
    v1() {
      activateSearchVariant();
    },
    reset() {
      this.control();
    }
  };

  document.addEventListener('page:load', () => window.convertSearchVariant.control?.());
})();
